import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import AddGuestsModal from "./AddGuestsModal";
import AddCustomQuestionModal from "./AddCustomQuestionModal";
import { Button, Form, Row, Col, Card } from "react-bootstrap";
import { useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../config";

axios.defaults.withCredentials = true;
axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem(
  "token"
)}`;
const defaultQuestions = [
  {
    id: 1,
    label: "Your Name",
    type: "text",
    required: true,
    visible: true,
    editable: true,
  },
  {
    id: 2,
    label: "Email address",
    type: "email",
    required: true,
    visible: true,
    editable: true,
  },
  {
    id: 3,
    label: "What is this meeting about?",
    type: "textarea",
    required: false,
    visible: true,
    editable: true,
  },
  {
    id: 4,
    label: "Additional Notes",
    type: "textarea",
    required: false,
    visible: true,
    editable: true,
  },
  {
    id: 5,
    label: "Add guests",
    type: "modal",
    required: false,
    visible: true,
    editable: true,
  },
  {
    id: 6,
    label: "Reason for reschedule",
    type: "text",
    required: false,
    visible: true,
    editable: true,
  },
];

let customIdCounter = 1000;

const BookingQuestions = forwardRef(({ eventId }, ref) => {
  const [questions, setQuestions] = useState(defaultQuestions);
  const [guests, setGuests] = useState([]);
  const [showAddGuestModal, setShowAddGuestModal] = useState(false);
  const [showAddCustomQuestionModal, setShowAddCustomQuestionModal] =
    useState(false);
  useEffect(() => {
    if (!eventId) return;

    axios
      .get(`${API_BASE_URL}/event/${eventId}/eventqueries`)
      .then((response) => {
        const data = response.data;

        if (Array.isArray(data) && data.length > 0) {
          const apiQuestions = data.map((q) => ({
            id: q.id,
            label: q.label,
            type: q.type,
            required: Boolean(Number(q.required)),
            visible: Boolean(Number(q.visible)),
            editable: false,
            placeholder: q.placeholder || "",
          }));
          setQuestions(apiQuestions);
        } else {
          // Fallback to default questions if no event-specific questions exist
          setQuestions(defaultQuestions);
        }
      })
      .catch((error) => {
        console.error("Error loading booking questions:", error);
        setQuestions(defaultQuestions); // Fallback on error too
      });
  }, [eventId]);
  const handleAddGuest = (guest) => {
    setGuests([...guests, guest]);
  };

  const handleAddCustomQuestion = ({
    questionLabel,
    placeholder,
    inputType,
    isMandatory,
  }) => {
    const custom = {
      id: customIdCounter++,
      type: inputType.toLowerCase(),
      label: questionLabel,
      placeholder: placeholder,
      required: isMandatory,
      visible: true,
      editable: true,
    };
    setQuestions([...questions, custom]);
  };

  const handleToggle = (id, key) => {
    const updated = questions.map((q) =>
      q.id === id ? { ...q, [key]: !q[key] } : q
    );
    setQuestions(updated);
  };

  const handleLabelChange = (id, value) => {
    const updated = questions.map((q) =>
      q.id === id ? { ...q, label: value } : q
    );
    setQuestions(updated);
  };

  useImperativeHandle(ref, () => ({
    getState: () => ({
      questions,
      guests,
    }),
  }));

  return (
    <div className="booking-questions">
      <h4>Booking Questions</h4>

      <div className="mb-3">
        <button
          className="btn btn-success me-2"
          onClick={() => setShowAddCustomQuestionModal(true)}
        >
          Add Custom Question
        </button>
        <button
          className="btn btn-success"
          onClick={() => setShowAddGuestModal(true)}
        >
          Add Guest
        </button>
      </div>

      {questions.map((q) => (
        <div key={q.id} className="question-box p-3 border rounded mb-3">
          <div className="d-flex align-items-center justify-content-between mb-2">
            {q.editable ? (
              <input
                type="text"
                className="form-control"
                value={q.label}
                onChange={(e) => handleLabelChange(q.id, e.target.value)}
                onBlur={() => handleToggle(q.id, "editable")}
                autoFocus
              />
            ) : (
              <>
                <label className="form-label mb-0">
                  {q.label || q.placeholder || "Untitled"}
                </label>
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => handleToggle(q.id, "editable")}
                >
                  <i className="bi bi-pencil"></i> Edit
                </button>
              </>
            )}
          </div>

          <div className="toggles d-flex gap-2">
            <label className="form-check me-3">
              <input
                type="checkbox"
                className="form-check-input me-1"
                checked={q.required}
                onChange={() => handleToggle(q.id, "required")}
              />
              Required
            </label>
            <label className="form-check">
              <input
                type="checkbox"
                className="form-check-input me-1"
                checked={q.visible}
                onChange={() => handleToggle(q.id, "visible")}
              />
              Visible
            </label>
          </div>
        </div>
      ))}

      {showAddCustomQuestionModal && (
        <AddCustomQuestionModal
          show={showAddCustomQuestionModal}
          onHide={() => setShowAddCustomQuestionModal(false)}
          onSave={handleAddCustomQuestion}
        />
      )}

      <div className="mt-4">
        <h4>Guests</h4>
        <ul className="list-group mt-2">
          {guests.map((guest, index) => (
            <li key={index} className="list-group-item">
              {guest.guestName} ({guest.guestEmail})
            </li>
          ))}
        </ul>
      </div>

      <AddGuestsModal
        show={showAddGuestModal}
        onHide={() => setShowAddGuestModal(false)}
        onSave={handleAddGuest}
      />
    </div>
  );
});

export default BookingQuestions;
